/* eslint-disable react/no-unknown-property */
import PageLayout from 'components/Layouts/PageLayout/PageLayout';
import PageLoader from 'components/Loaders/PageLoader';
import {
  useAppDispatch, useAppSelector,
} from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { storageActions } from 'store/storage';
import { ServiceCode } from 'store/user/types/service';
import { ReactComponent as StorageIcon } from 'assets/icons_3/box.svg';
import ServiceNoData from 'components/ServiceNoData/ServiceNoData';
import Modal from 'components/UI_kit_3/Modal/Modal';
import ProgressBarCustom from 'components/UI_Kit/ProgressBar/ProgressBar';

const StorageLayout: React.FC = () => {
  const storageAccess = useAppSelector((state) => state.storage);
  const user = useAppSelector((state) => state.user);
  const [t] = useTranslation();
  const uploading = useAppSelector((state) => state.storage.uploading);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (!storageAccess.loading && storageAccess.isStorageActive === false
      && location.pathname !== '/services/storage/bucket/create') {
      navigate('/services/storage');
    }
  }, [location.pathname]);

  const isServiceEnabledInRegion = React.useMemo(() => {
    const storageServices = user.services.filter((service) => service.code === ServiceCode.storage);
    if (storageServices.length === 0) {
      return false;
    }
    return storageServices.some((service) => service.regionId === user.region?.id);
  }, [user]);

  const enabledRegions = user.services
    .filter((service) => service.code === ServiceCode.storage)
    .map((service) => service.regionId)
    .map((regionId) => user.regions.find((region) => region.id === regionId)?.name);

  if (storageAccess.loading || storageAccess.isStorageActive === null) {
    return <PageLoader />;
  }

  if (!storageAccess.loading) {
    return (
      <PageLayout title={t('storage.self')}>
        {uploading.progress !== null && uploading.files.length > 1 && (
          <ProgressBarCustom
            className="my-md"
            label={t('storage.uploading_files')}
            progress={uploading.progress}
          />
        )}
        {isServiceEnabledInRegion ? (
          <Outlet />
        ) : (
          <ServiceNoData
            icon={<StorageIcon />}
            title={t('storage.self')}
            descriptions={[`${t('no_data.region_disabled_1')} "${t('storage.self')}" ${t('no_data.region_disabled_2', { availabilityZone: enabledRegions.join(', ') })}.`]}
          />
        )}
        <Modal show={uploading.error === '6'} onHide={() => dispatch(storageActions.stopUpload())}>
          <Modal.Header closeButton>{t('storage.exceeding_limits')}</Modal.Header>
          <Modal.Body>
            <p>{t('storage.exceeding_limits_decs_1')}</p>
            <p>{t('storage.exceeding_limits_decs_2')}</p>
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </PageLayout>
    );
  }
  return null;
};

export default StorageLayout;
